import React from "react";
import playersDataTemp from "./tempData";
import closeIcon from "../../../../../assets/images/dw20/icons/close.svg";
import cx from "classnames";
import { connect } from "react-redux";
import { removeUser } from "../../../../../components/shared/utils";
import { withSocket } from "../../../../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import tick from "./tick.png";

const Player = (props) => {
  const {
    display_name,
    profile_image,
    player_id,
    count = 0,
    name,
    cardCzar = false,
    image,
    roomData,
    users,
    roomObj,
  } = props;
  let playedCards = props.gameReducer.roomObj.game_state.played_cards;
  let score = roomData.player_hands;
  // let score = [{ score: 6 }];
  let card = cardCzar;
  if (player_id === roomData.active_player) {
    card = true;
  }
  let tickImage = false;

  playedCards &&
    playedCards.length > 0 &&
    playedCards.map((item) => {
      if (player_id === item.player_id) {
        tickImage = true;
      }
    });

  let dltUser =
    users &&
    users.length > 0 &&
    users.filter((item) => {
      return item.player_id === player_id;
    });

  const delPlayer = (data) => {
    const roomObj = props.roomObj && props.roomObj;
    removeUser(roomObj, data);
  };

  return (
    <div className={cx("dw20-player", { cardCzar: card })}>
      <div className="dw20-player-content">
        <div className="player">
          <div className="imageWrapper">
            {tickImage && <img src={tick} className="tick" alt="tick" />}
            <img src={profile_image} alt={display_name} className="image" />
          </div>
          <div className="name-wrapper">
            <p className="name">{display_name}</p>
            {card && <p className="cardCzar-text">CARD CZAR</p>}
          </div>
        </div>
        <div className="count-wrap">
          {score &&
            score.length > 0 &&
            score.map((item) => {
              if (item.player_id === player_id) {
                return <p className="count">{item.score}</p>;
              }
            })}
        </div>
        <button className="close" onClick={() => delPlayer(dltUser[0])}>
          <img src={closeIcon} />
        </button>
      </div>
    </div>
  );
};
const hexToRGB = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha !== "") {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};

const Sidebar = (props) => {
  let playersData = props.gameReducer.roomObj.users;
  let roomData = props.gameReducer.roomObj.game_state;
  let users = props.gameReducer.roomObj.users;
  let roomObj = props.gameReducer.roomObj;
  let parameter = props.paramsReducer.gameObj;
  let backgroundColor = parameter?.tabletop_placemat_rgb;
  let backgroundTrans = parameter?.tabletop_placemat_transparency;
  let colors = "";
  if (backgroundColor) {
    colors = hexToRGB(backgroundColor, backgroundTrans);
  }
  return (
    <div className="dw20-sidebar" style={{ backgroundColor: colors }}>
      <h2 className="player-title">Players</h2>
      <div className="dw20-player-list">
        {playersData &&
          playersData.length > 0 &&
          playersData.map((data, index) => (
            <Player
              key={index}
              {...data}
              roomData={roomData}
              users={users}
              roomObj={roomObj}
              {...props}
            />
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(Sidebar);
